var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.875 1.375h30.25a2.75 2.75 0 0 1 2.75 2.75v19.25a2.75 2.75 0 0 1-2.75 2.75H6.875a2.75 2.75 0 0 1-2.75-2.75V4.125a2.75 2.75 0 0 1 2.75-2.75m31.198 39.541a1.373 1.373 0 0 1-1.335 1.709H7.263a1.374 1.374 0 0 1-1.335-1.709l2.063-8.25a1.37 1.37 0 0 1 1.335-1.041h25.351c.63 0 1.18.429 1.335 1.041zM4.125 20.625h35.75m-27.5 16.5h2.75m13.75 0h2.75m-11 0h2.75"
  })));
};
export default SvgComputer;